(function ($) {

    let floorMapInitialized = false;
    $.imageMapProInitialized = function(imageMapName) {
        $( ".imp-shape-rect" ).each(function() {
            let element = $(this);
            let shapeTitle = $(this).data('shape-title');
            let shapeIndex = $(this).data('index');
            let squareTooltip = $(".imp-tooltip[data-index='"+shapeIndex+"']").find('.squares-element');
            $.each(apartments,function(index,apartment){
                if(apartment.id == shapeTitle) {
                    if(apartment.status =='booked' || apartment.status == 'sold') {
                        element.addClass('not-available');
                        element.html('<h3>'+apartment.number+'</h3><p>'+apartment.status_name+'</p>')
                    }else {
                        squareTooltip.html('<h3>'+apartment.area+'</h3><p>'+ apartment.rooms +'</p>' + (apartment.is_price_visible && apartment.price ? '<p>' + apartment.price + ' €</p>' : ''))
                        element.html('<a href="'+apartment.link+'"><h3>'+apartment.number+'</h3></a>')
                    }
                }
            });

        });

        let current_apartment = $('.map-floor-svg').data('current-apartment');
        $(`[data-shape-title=${current_apartment}]`).addClass('active');
        $('.map-floor-svg').scrollLeft(($('.map-floor-svg .imp-main-image').width() - window.innerWidth) / 2);
        let currentFloor = $('.map-floor-svg').data('current-floor');
        if ($('.map-floor-svg .imp-ui-layers-select option').length && !floorMapInitialized) {
            $('.map-floor-svg .imp-ui-layers-select option').each(function(i, el) {
                console.log('index: ' + i);
                console.log('current: ' + currentFloor);
                if ( i == currentFloor ) {
                    $('.other-apartments .floors-blocks .floors').append(`
                        <div data-title="${$(el).val()}" class="single-floor-item active">${$(el).text()}</div>
                    `);

                } else {
                    $('.other-apartments .floors-blocks .floors').append(`
                        <div data-title="${$(el).val()}" class="single-floor-item">${$(el).text()}</div>
                    `);
                }

                if ( i == currentFloor ) {
                    $('.map-floor-svg .imp-ui-layers-select option:eq('+i+')').prop('selected', true);
                    $('.map-floor-svg .imp-ui-layers-select').trigger('change');
                    console.log('seleced!');
                }

                //$('.other-apartments .floors-blocks .floors').append(`
                //        <div data-title="${$(el).val()}" class="single-floor-item ${i === 0 ? "active" : ""}">${$(el).text()}</div>
                //    `);
            });

            $('.other-apartments .floors .single-floor-item').on('click', function() {
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active').siblings().removeClass('active');
                    $('.map-floor-svg .imp-ui-layers-select').val($(this).data('title')).trigger('change')
                }
            });

            if (!$('.map-floor-svg .imp-ui-layers-select option').length) {
                $('.other-apartments .floors').addClass('empty');
            }
        }
        floorMapInitialized = true;
    }

    // NEW
    //
    //imageMapProGoToFloor
    /*
    let floorMapInitialized = false;
    $.imageMapProInitialized = function(imageMapName) {

        // Markers data
        //
        $( ".imp-shape-rect" ).each(function() {
            let element = $(this);
            let shapeTitle = $(this).data('shape-title');
            let shapeIndex = $(this).data('index');
            let squareTooltip = $(".imp-tooltip[data-index='"+shapeIndex+"']").find('.squares-element');
            $.each(apartments,function(index,apartment){
                if(apartment.id == shapeTitle) {
                    if(apartment.status =='booked' || apartment.status == 'sold') {
                        element.addClass('not-available');
                        element.html('<h3>'+apartment.number+'</h3><p>'+apartment.status_name+'</p>')
                    }else {
                        squareTooltip.html('<h3>'+apartment.area+'</h3><p>'+ apartment.rooms +'</p><p>'+(apartment.price ? apartment.price +' €' : '' )+'</p>')
                        element.html('<a href="'+apartment.link+'"><h3>'+apartment.number+'</h3></a>')
                    }
                }
            });
        });

        // Create nice floor selections
        //
        $( '.c-houses-list__item' ).each(function( index, element ) {

            var currentFloorSelectOptions = $(this).find('.imp-ui-layers-select option');
            var currentFloorTarget = $(this).find('.c-choose-list .btn-group');

            console.log(currentFloorSelectOptions);

            var currentFloorSelectOptionsValues = $.map( currentFloorSelectOptions, function(option) {
                console.log(option);
                $(currentFloorTarget).append('<button type="button" data-liven-floor="'+option.value+'">'+option.text+'</button>');
            });

        });

        // ImageMapPro initialized
        //
        floorMapInitialized = true;
    }

    // On click change floor
    //
    $( document ).on( 'click', '[data-liven-floor]', function() {
        console.log('click');
        $('#house-57').find('.imp-ui-element.imp-ui-layers-select').val(2).trigger('change');

    });
    */

})(jQuery);
